module.exports = "a {\n  color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/statistic/statistic.component.scss
// module id = 721
// module chunks = 1